import { c as _c } from "react/compiler-runtime";
import { Nav, NavUl } from '../components';
import { NavList } from './nav-desktop-list';

// ----------------------------------------------------------------------

export function NavDesktop(t0) {
  const $ = _c(17);
  let data;
  let other;
  let sx;
  if ($[0] !== t0) {
    ({
      data,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = data;
    $[2] = other;
    $[3] = sx;
  } else {
    data = $[1];
    other = $[2];
    sx = $[3];
  }
  let t1;
  if ($[4] !== sx) {
    t1 = Array.isArray(sx) ? sx : [sx];
    $[4] = sx;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = [...t1];
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: 5,
      height: 1,
      flexDirection: "row",
      alignItems: "center"
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== data) {
    t4 = data.map(_temp);
    $[9] = data;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <NavUl sx={t3}>{t4}</NavUl>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== other || $[14] !== t2 || $[15] !== t5) {
    t6 = <Nav sx={t2} {...other}>{t5}</Nav>;
    $[13] = other;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp(list) {
  return <NavList key={list.title} data={list} />;
}